<template>
  <img
    :src="require(`@/assets/img/type/${currentIcon.img}`)"
    :alt="currentIcon.alt"
    :title="currentIcon.title"
    loading="lazy"
    :height="24"
    :width="28"
  />
</template>

<script>
import { typeToTitle } from '@/tools'

export default {
  name: 'GlTransactionIcon',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    currentIcon() {
      const icons = {
        MINTING: {
          img: 'minting.svg',
          alt: 'Minting Transaction',
          title: 'Minting Transaction',
        },
        MINTING_CONTRACT: {
          img: 'minting-contract.svg',
          alt: 'Minting Contract',
          title: 'Minting Contract',
        },
        FUNDING_CONTRACT: {
          img: 'funding-contract.svg',
          alt: 'Funding Contract',
          title: 'Funding Contract',
        },
        PLATINCOIN_CONTRACT: {
          img: 'platincoin-contract.svg',
          alt: 'Platincoin Contract',
          title: 'Platincoin Contract',
        },
        BOT_CONTRACT: {
          img: 'bot-contract.svg',
          alt: 'Bot Contract',
          title: 'Bot Contract',
        },
        BOT_CONTRACT_DEACTIVATION: {
          img: 'bot-contract-deactivation.svg',
          alt: 'Bot Contract',
          title: 'Bot Contract',
        },
        DEAL_CONTRACT: {
          img: 'deal-contract.svg',
          alt: 'Deal Contract',
          title: 'Deal Contract',
        },
        COINBASE: {
          img: 'coinbase.svg',
          alt: 'Coinbase',
          title: 'Coinbase',
        },
        ACTIVATION: {
          img: 'activation.svg',
          alt: 'Activation',
          title: 'Activation',
        },
        STANDARD: {
          img: 'standard.svg',
          alt: 'Standard Transaction',
          title: 'Standard Transaction',
        },
      }
      return (
        icons[this.type] || {
          img: 'standard.svg',
          alt: typeToTitle(this.type),
          title: typeToTitle(this.type),
        }
      )
    },
  },
}
</script>
